// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteLoadProduct,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import setCustomProductState from "@steiner/App/Handlers/ProductDetails/SetCustomProductState";
import { VideoDocumentModel } from "@steiner/App/Store/Reducers/xProductDetails";

export function getVideosList(product: ProductModel) {
    return JSON.parse(product.properties?.webVideos || "[]");
}

export function parseProductCustomState(product: ProductModel) {
    let videos: VideoDocumentModel[] = getVideosList(product);

    let selectedVideoIndex = -1;
    if (videos?.length > 0 && product?.images?.length === 0) {
        selectedVideoIndex = 0;
    }

    videos = videos.map((video, index) => ({
        id: index,
        ...video,
    }));

    return {
        productId: product.id,
        videos,
        selectedVideoIndex,
    };
}

export const XngDispatchCompleteLoadProduct: typeof DispatchCompleteLoadProduct = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch(setCustomProductState({ customProductStates: [parseProductCustomState(props.apiResult)] }));
};

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    props.apiParameter.expand?.push("properties");
};

addToChainAfter(chain, DispatchCompleteLoadProduct, XngDispatchCompleteLoadProduct);
addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
